import { render, staticRenderFns } from "./documentMasterDetail.vue?vue&type=template&id=72dce2bb"
import script from "./documentMasterDetail.vue?vue&type=script&lang=js"
export * from "./documentMasterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72dce2bb')) {
      api.createRecord('72dce2bb', component.options)
    } else {
      api.reload('72dce2bb', component.options)
    }
    module.hot.accept("./documentMasterDetail.vue?vue&type=template&id=72dce2bb", function () {
      api.rerender('72dce2bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/documentMasterDetail.vue"
export default component.exports